import styled from 'styled-components';
import { Button } from '../utils/Button/Button';
import Image from '../utils/Image/Image';
import { Text12ExtraBold, Text14Regular } from '../utils/Text/Text.styles';
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;

  svg {
    cursor: pointer;
  }
`;

export const TooltipContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #badaf7;
  background: #eef5fd;
  padding: 1.2rem;
  position: absolute;
  width: 45rem;
  left: 14rem;
  top: 1rem;
`;

export const InviteButton = styled(Button)`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, var(--Blue-500, #3e9be4) 6.75%, var(--Blue-700, #1672ba) 93.25%);
  padding: 1.2rem;
  font-size: 1.4rem;
  font-weight: 400;
  width: 15rem;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const Item = styled.div`
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  background: #fff;
  padding: 1.2rem;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 500px) {
    justify-content: space-between;
  }
`;

export const ImageContainer = styled(Image)`
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  width: 40%;
`;

export const TagText = styled(Text12ExtraBold)`
  color: #1775be;
  font-weight: 500;
  letter-spacing: 0.48px;
  text-transform: uppercase;
`;

export const Text = styled(Text14Regular)`
  line-height: 22px;
  letter-spacing: 0.07px;
`;
